import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useButtonText, useSubmitClickHandler } from '../hooks';

interface IAddNewCardButtonProps {
  buttonRef?: React.Ref<HTMLDivElement>;
}

export const AddNewCardButton: React.FC<IAddNewCardButtonProps> = ({ buttonRef }) => {
  const buttonText = useButtonText();
  const handleClick = useSubmitClickHandler();

  return (
    <div ref={buttonRef}>
      <Button onClick={handleClick} size="L" fullWidth>
        {buttonText}
      </Button>
    </div>
  );
};
